module.exports = __webpack_public_path__ + "img/icon-youyou-left.34897659.gif";